import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Navbar } from "@/components/Navbar";
import { useLang } from "@/lib/i18n";
import api, { apiError } from "@/lib/api";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background blueprint-grid">
      <Navbar />
      <div className="max-w-md mx-auto px-4 pt-16 sm:pt-24 pb-16">
        <div className="border border-border rounded-xl bg-card p-8 fade-up">
          <h1 className="font-heading font-extrabold text-2xl tracking-tight">{t("forgot_password_title")}</h1>
          {sent ? (
            <div className="mt-8 text-center" data-testid="forgot-password-sent">
              <MailCheck className="h-10 w-10 text-accent mx-auto mb-4" />
              <p className="text-sm text-muted-foreground leading-relaxed">{t("reset_sent")}</p>
              <Link to="/login" data-testid="back-to-login-link" className="text-sm text-accent hover:underline block mt-6">{t("back_to_login")}</Link>
            </div>
          ) : (
            <>
              <p className="text-sm text-muted-foreground mt-2">{t("forgot_password_text")}</p>
              <form onSubmit={submit} className="mt-8 space-y-5">
                <div className="space-y-2">
                  <Label htmlFor="email">{t("email")}</Label>
                  <Input id="email" type="email" data-testid="forgot-password-email-input" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                {error && <p data-testid="forgot-password-error" className="text-sm text-destructive">{error}</p>}
                <Button type="submit" data-testid="forgot-password-submit-btn" disabled={loading} className="w-full rounded-full active:scale-95">
                  {loading ? "..." : t("send_reset_link")}
                </Button>
              </form>
              <p className="text-sm text-muted-foreground text-center mt-6">
                <Link to="/login" data-testid="back-to-login-link" className="text-accent hover:underline">{t("back_to_login")}</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
